module.exports = __webpack_public_path__ + "img/placeholder_boy_2x.3fb134b3.png";